import '@babel/polyfill';
import './reset.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { addEventListener } from 'ThreeTerminal_base/base';
import styles from './app.css';

class Demo extends React.PureComponent {
    state = {
        width: 1000,
        height: 800,
    };

    componentDidMount() {
        this.resize = addEventListener(window, 'message', this.handleResize);
        this.scroll = addEventListener(window, 'scroll', this.handleScroll);
    }

    componentWillUnmount() {
        this.resize();
        this.scroll();
    }

    handleResize = async e => {
        const { width, height } = this.state;

        if (typeof e.data === 'string') {
            if (e.data.indexOf('*') > -1) {
                console.log(e.data);

                this.handleScroll();

                const wh = e.data.split('*');
                const [w, h] = wh;

                if (width !== w || height !== h) {
                    this.setState({
                        width: w,
                        height: h,
                    });
                }
            }

            if (e.data.indexOf('#') === 0) {
                console.log(e.data);

                const h = Number(e.data.slice(1));

                scrollTo(0, h);
            }
        }
    };

    handleScroll = () => {
        const currentTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

        const data = {
            currentTop,
            innerHeight: window.innerHeight,
        };

        console.log(data);

        document.getElementById('mainFrame').contentWindow.postMessage(data, '*');
    };

    render() {
        const { width, height } = this.state;

        console.log(width, height);

        return (
            <div className={styles.frameBox} style={{ width: `${window.innerWidth}px`, height: `${height}px` }}>
                <iframe
                    id="mainFrame"
                    name="mainFrame"
                    src="http://dianshi10.com/Assetallocation/FlyerPage_ifeng"
                    frameBorder="no"
                    border="0"
                    scrolling="no"
                    width={window.innerWidth}
                    height={height}
                />
            </div>
        );
    }
}

ReactDOM.render(<Demo />, document.getElementById('root'));
